import Box from '@totallymoney/ui/components/Box'
import Heading from '@totallymoney/ui/components/Heading'

import { ScoredCreditCardProduct } from '@appTypes/EligibilityApi.interface'

import UnorderedList, { ListItem } from '@components/UnorderedList'

import { borderStyle } from '@styles/borderStyle'

const StyledBorder = () => <Box borderBottom={borderStyle} mb="space20" />

const CardPageProductLists = ({ card }: { card: ScoredCreditCardProduct }) => (
    <Box
        display="grid"
        gridTemplateColumns={['1fr', '1fr 1fr']}
        gridGap={['space30', 'space50']}
    >
        <Box>
            <Box mb="space10">
                <Heading as="h2" variant="60">
                    What’s Good
                </Heading>
            </Box>

            <StyledBorder />

            <UnorderedList>
                {card.pros?.map(pro => <ListItem key={pro}>{pro}</ListItem>)}
            </UnorderedList>
        </Box>
        <Box>
            <Box mb="space10">
                <Heading as="h2" variant="60">
                    What’s Bad
                </Heading>
            </Box>

            <StyledBorder />

            <UnorderedList>
                {card.cons?.map(pro => <ListItem key={pro}>{pro}</ListItem>)}
            </UnorderedList>
        </Box>

        <Box>
            <Box mb="space10">
                <Heading as="h2" variant="60">
                    Features
                </Heading>
            </Box>

            <StyledBorder />

            <UnorderedList>
                {card.features?.map(pro => (
                    <ListItem key={pro}>{pro}</ListItem>
                ))}
            </UnorderedList>
        </Box>

        <Box>
            <Box mb="space10">
                <Heading as="h2" variant="60">
                    Eligibility
                </Heading>
            </Box>

            <StyledBorder />

            <UnorderedList>
                {card.eligibility?.map(pro => (
                    <ListItem key={pro}>{pro}</ListItem>
                ))}
            </UnorderedList>
        </Box>
    </Box>
)

export default CardPageProductLists
